import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FiArrowLeftCircle, FiArrowRightCircle } from "react-icons/fi";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import * as Styles from "./BenefitSlider.styles";
import { getS3ImageUrl } from "configs/utils";
import Placeholder from "assets/images/placeholder.jpg";

const BenefitSlider = ({ testimonials }) => {
  console.log("🚀 ~ BenefitSlider ~ testimonials:", testimonials);
  // Default testimonials if none provided

  const renderStars = (count) => {
    return "★".repeat(count);
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <FiArrowLeftCircle
        onClick={onClick}
        color="rgb(160, 195, 221)"
        size={24}
      />
    );
  };

  const NextArrow = (props) => {
    const { onClick } = props;
    return <FiArrowRightCircle onClick={onClick} color="#2ECF96" size={24} />;
  };

  return (
    <Styles.SliderContainer>
      <Styles.TopRow>
        <Styles.Title>Kundenfeedback</Styles.Title>
        <Styles.CustomNavigation>
          <div className="swiper-button-prev custom">
            <PrevArrow />
          </div>
          <div className="swiper-pagination"></div>
          <div className="swiper-button-next custom">
            <NextArrow />
          </div>
        </Styles.CustomNavigation>
      </Styles.TopRow>

      <Swiper
        spaceBetween={20}
        slidesPerView={1}
        loop={true}
        modules={[Navigation, Pagination]}
        navigation={{
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        }}
        pagination={{
          clickable: true,
          dynamicBullets: false,
          el: ".swiper-pagination",
        }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <Styles.TestimonialCard>
              <Styles.TestimonialHeader>
                <Styles.ProfileImageWrapper>
                  <img
                    src={
                      testimonial?.picture
                        ? getS3ImageUrl(testimonial?.picture)
                        : Placeholder
                    }
                    alt={testimonial.name}
                  />
                </Styles.ProfileImageWrapper>
                <Styles.TestimonialUser>
                  <Styles.Stars>{renderStars(testimonial.stars)}</Styles.Stars>
                  <Styles.UserName>
                    {testimonial.prename} {testimonial.lastname}
                  </Styles.UserName>
                  {/* <Styles.UserAge>{testimonial.age}</Styles.UserAge> */}
                </Styles.TestimonialUser>
              </Styles.TestimonialHeader>
              <Styles.TestimonialText>
                {testimonial.text.slice(0, 300) + "..."}
              </Styles.TestimonialText>
            </Styles.TestimonialCard>
          </SwiperSlide>
        ))}
      </Swiper>
    </Styles.SliderContainer>
  );
};

export default BenefitSlider;
